(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["cooktop-compatibility"] && !Shopify.designMode) return;
  try {
    (function () {
    function openModal(modal) {
      modal.removeAttribute('hidden');
      document.body.style.overflow = 'hidden';
      const closeIcon = modal.querySelector('.cooktop-modal__close-icon');
      if (closeIcon) closeIcon.focus();
    }

    function closeModal(modal) {
      modal.setAttribute('hidden', '');
      document.body.style.overflow = '';
    }

    document.addEventListener('click', function (e) {
      // Open
      const trigger = e.target.closest('.cooktop-compat__trigger');
      if (trigger) {
        const modal = document.getElementById(trigger.getAttribute('aria-controls'));
        if (modal) openModal(modal);
        return;
      }

      // Close: X icon button or text close button
      const closeBtn = e.target.closest('.cooktop-modal__close-icon, .cooktop-modal__close-btn');
      if (closeBtn) {
        closeModal(closeBtn.closest('.cooktop-modal'));
        return;
      }

      // Close: backdrop
      if (e.target.classList.contains('cooktop-modal__backdrop')) {
        closeModal(e.target.closest('.cooktop-modal'));
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      document.querySelectorAll('.cooktop-modal:not([hidden])').forEach(closeModal);
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
